export const WEB_TYPE = {
  TUTORABC: "tutorabc",
  TUTORABC_CN: "tutorabc_cn",
};

export const DEFAULT_WEB_TYPE = WEB_TYPE.TUTORABC;
export const webType = process.env.WEB_TYPE || DEFAULT_WEB_TYPE;



// WEBPACK FOOTER //
// ./src/constants/webType.js